import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/auth";
import { useLanguage } from "@/i18n";
import { track } from "@/utils/track";

export default function FavoriteButton({ slug, className = "" }) {
  const { user, favorites, toggleFavorite } = useAuth();
  const { t } = useLanguage();
  const saved = favorites.has(slug);

  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      toast(t("login_to_save"));
      return;
    }
    await toggleFavorite(slug);
    track(saved ? "favorite_remove" : "favorite_add", { slug });
    toast(saved ? t("removed_favorite") : t("saved_favorite"));
  };

  return (
    <button
      onClick={onClick}
      data-testid={`favorite-button-${slug}`}
      aria-label={saved ? t("remove") : t("save_experience")}
      className={`bg-ivory/90 backdrop-blur p-2.5 transition-colors duration-300 hover:bg-ivory ${className}`}
    >
      <Heart size={16} strokeWidth={1.5} className={saved ? "fill-terracotta text-terracotta" : "text-ink/60"} />
    </button>
  );
}
